import React from 'react';

import styles from './popover-content.scss';
import Icon from '../icon';
import roleIcons from '../../constants/role-icons';

interface Props {
  children: string;
}

export const RoleActionIcon: React.StatelessComponent<Props> = ({ children }) => {
  const RoleIcon = roleIcons[children];
  if (!RoleIcon) {
    return null;
  }
  return <Icon icon={<RoleIcon />} className={styles.actionIcon} iconClassName="ma-popover-roles-icon-fill" />;
};
